import { render, staticRenderFns } from "./EditHaircutImportModal.vue?vue&type=template&id=841c9cde"
import script from "./EditHaircutImportModal.vue?vue&type=script&lang=js"
export * from "./EditHaircutImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports